import { Theme as AugmentedTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Box, Button, Divider, Grid } from 'web-library';
import { joiResolver } from '@hookform/resolvers/joi';
import ContactDetails from '../../../../components/ContactDetails';
import PersonalDetails from '../../../../components/PersonalDetails';
import { CoordinatorResitAction } from '../../logic/useCoordinatorResitData';
import { CandidateProfileFormData } from '../../../../models';
import resitEditCandidateProfileSchema from '../../../accountManagement/schema/resitEditCandidateProfileSchema';

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export const useStyles = makeStyles()((theme) =>
({
  pageContent: {
    padding: theme.spacing(4),
  },
  pageTitle: {},
  formContainer: {
    width: '100%',
  },
}));

interface CandidateConfirmParticularProps {
  dispatch: React.Dispatch<CoordinatorResitAction>;
  selectedCandidate: number;
  candidateTableRows: {
    name: any;
    id: any;
  }[];
  state: any;
}

const CandidateConfirmParticular = ({
  dispatch,
  selectedCandidate,
  candidateTableRows,
  state,
}: CandidateConfirmParticularProps) => {
  const { classes } = useStyles();

  const [editMode, setEditMode] = useState(false);
  const onEdit = (isEdit: boolean) => {
    setEditMode(isEdit);
  };

  const pointer = state.resitCandidates?.[candidateTableRows[selectedCandidate]?.id] || {};

  const form = useForm<CandidateProfileFormData>({
    mode: 'onSubmit',
    resolver: joiResolver(resitEditCandidateProfileSchema()),


  });

  return (
    <>
      <Box key={selectedCandidate.toString()} className={classes.pageContent}>
        <PersonalDetails horizontalRule {...pointer} />

        <Divider />

        <form
          className={classes.formContainer}
          onSubmit={form.handleSubmit((formData: CandidateProfileFormData) => {
            let phoneNumber = null;
            if (
              formData.telephoneCountryCode !== undefined &&
              formData.telephoneContactNumber !== undefined
            ) {
              phoneNumber = {
                  countryCode: formData.telephoneCountryCode || null,
                  number: formData.telephoneContactNumber || null,
              };
            }
            dispatch({
              type: 'UPDATE_CANDIDATE_PARTICULARS',
              payload: {
                candidateParticular: {
                  ...pointer,
                  ...formData,
                  mailingAddress: {
                    houseOrBlockNumber: formData.houseOrBlkNo,
                    floorNumber: formData.floor,
                    buildingName: formData.building,
                    postalCode: formData.postalCode,
                    streetName: formData.streetName,
                    unitNumber: formData.unit,
                  },
                  mobileNumber: {
                    countryCode: formData.mobileCountryCode,
                    number: formData.mobileContactNumber,
                  },
                  phoneNumber,
                },
                candidateId: candidateTableRows[selectedCandidate]?.id,
              },
            } as CoordinatorResitAction);
            setEditMode(false);
          })}
        >
          <Grid xs={12} md={12}>
            <ContactDetails
              contactDetails={{
                ...pointer,
              }}
              onEdit={onEdit}
              formHook={form}
              editMode={editMode}
              editable
            />

            {editMode && <Button type="submit">Save</Button>}
          </Grid>
        </form>
      </Box>
    </>
  );
};

export default CandidateConfirmParticular;
